import {Observable, throwError as observableThrowError} from "rxjs";
import {Injectable} from "@angular/core";
import {Contract} from "./contract";
import {environment} from "../../environments/environment";
import {catchError, map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ContractService {
  CONTRACTS_URL: string = environment.api_base_url + "contracts";

  constructor(private http: HttpClient) {}

  fetchAll(): Observable<Contract[]> {
    return this.http.get(`${this.CONTRACTS_URL}`).pipe(
      map((res: Contract[]) => res.map(x => new Contract(x))),
      catchError(this.handleError)
    );
  }

  fetchPage(page: number, per: number, order_field: string, order_direction: string): Observable<Contract[]> {
    return this.http
      .get(
        `${this.CONTRACTS_URL}?page=${page}&per=${per}&order_field=${order_field}&order_direction=${order_direction}`
      )
      .pipe(
        map((res: Contract[]) => res.map(x => new Contract(x))),
        catchError(this.handleError)
      );
  }

  fetch(id: number): Observable<Contract> {
    return this.http.get(`${this.CONTRACTS_URL}/${id}`).pipe(
      map(res => new Contract(res)),
      catchError(this.handleError)
    );
  }

  downloadPDF(contract: Contract): Observable<Blob> {
    return this.http
      .get(`${this.CONTRACTS_URL}/${contract.id}/download`, {
        responseType: "blob"
      })
      .pipe(
        map(res => new Blob([res], {type: "image/pdf"})),
        catchError(this.handleError)
      );
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return observableThrowError(errMsg);
  }
}
